import { render, staticRenderFns } from "./SearchProjectsSort.vue?vue&type=template&id=2ad056fc&"
import script from "./SearchProjectsSort.vue?vue&type=script&lang=js&"
export * from "./SearchProjectsSort.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports